export class HttpDebugger {
    /*
    Called when http request is started
    */
    debugStartHttpRequest() {
    }
    /*
    Called when http request is resolved
    */
    debugSuccessHttpRequest() {
    }
    /*
    Called when http request is being retried
    */
    debugRetryHttpRequest() {
    }
}
export const httpDebugger = new HttpDebugger();
//# sourceMappingURL=http.debugger.js.map